import { useContext } from "react";
import { ArrowRightIcon, CloseIcon } from "../../assets/kits/Icons/Icons.tsx";
import LogInCode from "./LogInCode";
import LogInNumber from "./LogInNumber";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import WebInfoContext from "../../context/WebInfo/WebInfoContext.ts";

import logo from "../../assets/images/logo/logo.svg";
import ekia from "../../assets/images/ekia.png";

export default function Container({
  loginShow,
  setLoginShow,
  changeUserInformation,
}) {
  const [modal, setmodal] = useState(0);
  const [loginkey, setloginkey] = useState("");
  const [number, setnumber] = useState("");

  let SetNumber = (e) => {
    setnumber(e.target.value);
  };

  function changemodal(modalNumber) {
    setmodal(modalNumber);
  }

  function LoginKey(loginKey) {
    setloginkey(loginKey);
  }

  function Back() {
    setmodal(0);
  }
  return (
    <>
      <div style={{ direction: "rtl" }}>
        {/* <!-- Modal --> */}
        {/* <div
          className="modal fade"
          id="ModalNumber1"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ zIndex: "1000" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header d-flex flex-row justify-content-between"> */}
        <Modal
          show={loginShow}
          onHide={() => {
            setLoginShow(false);
          }}
          className="new-style-login" //shFazeli 1402/04/31
        >
          {/* shFazeli 1402/04/31 start */}
          {/* <Modal.Header closeButton>
            {modal == 0 ? (
              ""
            ) : (
              <button
                type="button"
                className="btn border"
                style={{ boxShadow: "none" }}
                onClick={Back}
              >
                بازگشت
              </button>
            )}
          </Modal.Header> */}
          {/* shFazeli 1402/04/31 end */}
          <Modal.Body style={{ height: 450 }}>
            {/* shFazeli 1402/04/31 start */}
            <div
              className="position-relative rounded"
              style={{
                width: "100%",
                height: 250,
                // backgroundColor: "rgb(98 23 23)",
                backgroundImage:
                  "linear-gradient(to right bottom, maroon, #EE384E,maroon)",
              }}
            >
              <div
                className="d-flex position-absolute rounded-pill d-flex align-items-center justify-content-center shadow"
                style={{
                  zIndex: 2,
                  backgroundColor: "white",
                  left: -8,
                  top: -6,
                  cursor: "pointer",
                }}
                onClick={() => {
                  setLoginShow(false);
                  changemodal(0);
                }}
              >
                <CloseIcon color="red" />
              </div>

              <div
                className="d-inline-block rounded-pill ms-1 shadow"
                style={{
                  zIndex: 2,
                  backgroundColor: "transparent",
                  cursor: "pointer",
                }}
                onClick={() => {
                  changemodal(0);
                }}
              >
                {modal == 1 ? <ArrowRightIcon color="white" /> : <></>}
              </div>

              <h5 className={`text-light text-center pt-1`}>
                ورود یا ثبت نام در فروشگاه
              </h5>
              <div
                style={{ width: "66px", height: "66px" }}
                className="rounded-pill wh-70 bg-white d-flex align-items-center justify-content-center mx-auto mt-3 overflow-hidden"
              >
                <img
                 
                  style={{ width: "60px", height: "40px" }}
                  src={ekia}
                />
              </div>
              {/* shFazeli 1402/04/31 end */}
              <div
                className="position-absolute mx-auto  shadow rounded"
                style={{
                  top: 150,
                  width: "95%",
                  right: "2.5%",
                  backgroundColor: "white",
                }}
              >
                {modal == 0 ? (
                  <LogInNumber
                    SetNumber={SetNumber}
                    number={number}
                    login={LoginKey}
                    ChangeModal={changemodal}
                  />
                ) : (
                  <LogInCode
                    ChangeModal={changemodal}
                    loginkey={loginkey}
                    SetNumber={SetNumber}
                    changeUserInformation={changeUserInformation}
                    number={number}
                    setLoginShow={setLoginShow}
                  />
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* </div>
          </div>
        </div> */}
      </div>
    </>
  );
}
